import { isEmpty } from "lodash";
import { Constant } from "../../../constants/constant";

export function propsToInitialState(data) {
  const dataInit = { ...data };
  dataInit.tinhTrangHoatDong = data?.tinhTrangHoatDong === false ? false : true;
  dataInit.phuongXa = data?.donViHanhChinh_Xa || null;
  dataInit.quanHuyen = data?.donViHanhChinh_Huyen || null;
  dataInit.tinhThanh = data?.donViHanhChinh_Tinh || Constant.TINHTHANH;
  dataInit.ngayHoatDong = data?.ngayHoatDong || null;
  dataInit.fileImages = data?.fileImage?.file_path
    ? [
        {
          bucket_name: data.fileImage?.bucket_name || null,
          file_path: data.fileImage?.file_path || null,
          file_oid: data.fileImage?.file_oid || 0,
          file_name: data.fileImage?.file_name || null,
          file_ext: data.fileImage?.file_ext || null,
          file_size: data.fileImage?.file_size || 0
        }
      ]
    : null;
  return dataInit;
}

export function parseDataSave(value) {
  const dataSave = { ...value };
  dataSave.ngayHoatDong = value?.ngayHoatDong || 0;
  dataSave.tinhTrangHoatDong = value?.tinhTrangHoatDong || false;
  dataSave.coQuanQuanLyId = value?.coQuanQuanLy?.id || 0;
  dataSave.maTinh = value?.tinhThanh?.maTinh || null;
  dataSave.maHuyen = value?.quanHuyen?.maHuyen || null;
  dataSave.maXa = value?.phuongXa?.maXa || null;
  dataSave.fileImage = value?.fileImages?.[0]?.file_path
    ? value?.fileImages?.[0]
    : null;
  // dataSave.roleId = value?.roles?.map(item => item?.id);
  return dataSave;
}
